(() => {
  if (window.florinoAutoScrollInitialized) return;
  window.florinoAutoScrollInitialized = true;
  const mobile = window.matchMedia('(max-width: 749px)');
  const tracks = new Map();

  function sync(track, state) {
    const active = mobile.matches && state.visible && !document.hidden && track.isConnected;
    if (active && state.timer === null) {
      state.timer = setInterval(() => advance(track, state), state.delay);
    } else if (!active && state.timer !== null) {
      clearInterval(state.timer);
      state.timer = null;
    }
  }

  function advance(track, state) {
    if (!track.isConnected) {
      sync(track, state);
      observer.unobserve(track);
      tracks.delete(track);
      return;
    }
    if (Date.now() < state.pausedUntil) return;
    const items = [...track.children];
    if (items.length < 2) return;
    const center = track.getBoundingClientRect().left + track.clientWidth / 2;
    let current = 0;
    let best = Infinity;
    items.forEach((item, i) => {
      const box = item.getBoundingClientRect();
      const distance = Math.abs(box.left + box.width / 2 - center);
      if (distance < best) { best = distance; current = i; }
    });
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 5;
    if (atEnd || current >= items.length - 1) {
      track.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      const box = items[current + 1].getBoundingClientRect();
      track.scrollTo({ left: track.scrollLeft + box.left + box.width / 2 - center, behavior: 'smooth' });
    }
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const state = tracks.get(entry.target);
      if (!state) return;
      state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.4;
      sync(entry.target, state);
    });
  }, { threshold: 0.4 });

  function setup(track) {
    if (track.dataset.autoScrollReady) return;
    track.dataset.autoScrollReady = 'true';
    const state = {
      delay: Number(track.dataset.autoScroll) || 3500,
      pausedUntil: 0,
      visible: false,
      timer: null
    };
    tracks.set(track, state);
    const pause = () => { state.pausedUntil = Date.now() + 6000; };
    track.addEventListener('touchstart', pause, { passive: true });
    track.addEventListener('pointerdown', pause, { passive: true });
    observer.observe(track);
  }

  const init = () => document.querySelectorAll('[data-auto-scroll]').forEach(setup);
  const syncAll = () => tracks.forEach((state, track) => sync(track, state));
  init();
  mobile.addEventListener('change', syncAll);
  document.addEventListener('visibilitychange', syncAll);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', (event) => {
    tracks.forEach((state, track) => {
      if (!event.target.contains(track)) return;
      if (state.timer !== null) clearInterval(state.timer);
      observer.unobserve(track);
      tracks.delete(track);
    });
  });
})();
